module.exports = __webpack_public_path__ + "static/farm-to-pantry-6f2f5905e640b8863cb5068f80e3db33.jpg";